import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useGlobalConfigContext } from '../global-config'
import { StaticImage } from '../image'
import {
  urlResolverGetContactMailPharmacy,
  urlResolverGetCounselor,
  urlResolverGetFaqPrescriptions,
  urlResolverGetMedicineLexicon,
  urlResolverGetPharmaLandingPage,
} from '../url-handling'

import { ErxHubArrowLink } from './ErxHubArrowLink'
import ImgAdvice from './images/ImgAdvice.png'

export const ErxHubAdviceCard: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <div className="flex flex-1 flex-col overflow-hidden rounded-m font-medium">
      <div className="h-36 w-full bg-light-brand-high">
        <StaticImage
          alt={intl.formatMessage({ id: 'nfc.moreInfo.advice.title' })}
          className="w-full"
          src={ImgAdvice}
        />
      </div>
      <div className="flex w-full grow gap-4 bg-light-brand-medium p-4">
        <span className="text-m">
          <FormattedMessage id="nfc.moreInfo.advice.title" />
        </span>

        <div className="flex w-full flex-col gap-2">
          <ErxHubArrowLink url={urlResolverGetPharmaLandingPage(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.advice.pharma" />
          </ErxHubArrowLink>
          <ErxHubArrowLink url={urlResolverGetCounselor(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.advice.counselor" />
          </ErxHubArrowLink>
          <ErxHubArrowLink url={urlResolverGetMedicineLexicon(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.advice.lexicon" />
          </ErxHubArrowLink>
          <ErxHubArrowLink url={urlResolverGetFaqPrescriptions(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.advice.faq" />
          </ErxHubArrowLink>
          <ErxHubArrowLink
            url={urlResolverGetContactMailPharmacy(globalConfig)}
          >
            <FormattedMessage id="nfc.moreInfo.advice.contact" />
          </ErxHubArrowLink>
        </div>
      </div>
    </div>
  )
}
